<div id="content">
  <div class="header" *ngIf="from !== 'app'" [ngClass]="{'header-top':lang=='CN', 'en-header-top':lang=='EN'}">
    <div class="p-grid p-align-center" style="margin: 0px;" *ngIf="lang=='CN'">
      <div class="p-lg-9 p-md-9 p-sm-12 p-justify-start">
        <a class='logo_box' href="http://www.eucleia.net/">
          <img *ngIf="lang=='CN'" src="assets/images/logo.png" />
        </a>
        <span class="header-menu">
          <span class="header_1" *ngIf="lang=='CN'">
            <!-- <a href="http://www.eucleia.net/">欧克勒亚</a> | -->
            <!-- <a href="/">可测车型</a> | -->
            <a href="/?lang=EN">English</a> |
            <a href="http://www.eucleia.net/index.php/Home/About/feedback" target="_blank" rel="noopener noreferrer">问题反馈</a>
          </span>
        </span>
      </div>
      <div class="header-title p-lg-3 p-md-3 p-sm-12 p-justify-end vertical-container">
        <span class='system_name' *ngIf="lang=='CN'">可测车型查询系统</span>
      </div>
    </div>
    <div class="p-grid p-align-center" style="margin: 0px;" *ngIf="lang=='EN'">
      <!-- <div class="logo_box p-col-1 p-justify-start">
              
          </div> -->
      <div class="p-lg-9 p-md-9 p-sm-12 p-justify-start">
        <a class='logo_box' href="http://www.eucleia.net/index.php/English">
          <img *ngIf="lang=='EN'" width="140px" src="assets/images/logo_en.png" />
        </a>
        <span class="header-menu c-l-sel">
          <span class="header_1" *ngIf="lang=='EN'">
            <!-- <a href="http://www.eucleia.net/index.php/English">EUCLEIA</a> | -->
            <a href="http://www.eucleia.net/index.php/English/About/feedback" target="_blank" rel="noopener noreferrer">Feedback</a> |
            <!-- <a href="http://autolist.eucleia.net/index.php?lg=EN">Measurable models</a> | -->
            <a href="https://shop-eucleia.myshopify.com/" target="brank">Shopify</a> |
            <a href="/?lang=CN">中文</a>
          </span>
        </span>
        <span class="header-menu c-p-sel">
          <div class="" style="margin-top: 5px;" *ngIf="lang=='EN'">
            <!-- <a href="http://www.eucleia.net/index.php/English">EUCLEIA</a> | -->
            <a href="http://www.eucleia.net/index.php/English/About/feedback" target="_blank" rel="noopener noreferrer">Feedback</a> |
            <!-- <a href="http://autolist.eucleia.net/index.php?lg=EN">Measurable models</a> | -->
            <a href="https://shop-eucleia.myshopify.com/" target="brank">Shopify</a> |
            <a href="/?lang=CN">中文</a>
          </div>
        </span>
      </div>
      <div class="header-title p-lg-3 p-md-3 p-sm-12 p-justify-end vertical-container">
        <span class='system_name' *ngIf="lang=='EN'">Vehicle Inquiry System</span>
      </div>
    </div>
  </div>
  <!-- 内容区域 -->
  <div class="detail" [ngClass]="{'detail-top':(lang=='CN' && from !== 'app'), 'en-detail-top':(lang=='EN' && from !== 'app')}">
    <div style="border-bottom: 1px solid gainsboro; margin-bottom: 1em; background-color: white;">
      <div class="c-l-sel">
        <div class="p-grid condition p-align-center">
          <div class="p-col-11">
            <div class="p-grid" style="margin: 0px;">
              <div class="p-col-3">
                <div class="filteritem" *ngIf="lang=='CN'">
                  <span>类型: </span>
                  <p-dropdown id="type" baseZIndex=1000 [ngClass]="{'brand-top': true}"
                    [disabled]="isLoading" emptyFilterMessage="没有类型" optionLabel="name" [options]="vehicleSwTypes"
                    [(ngModel)]="selectedType" placeholder="选择类型" (onChange)="onTypeSelected(selectedType.id)">
                  </p-dropdown>
                </div>
                <div class="filteritem" *ngIf="lang=='EN'">
                  <span>Type: </span>
                  <p-dropdown id="en-type" baseZIndex=1000 [ngClass]="{'brand-top': true}"
                    [disabled]="isLoading" optionLabel="enName" [options]="vehicleSwTypes" [(ngModel)]="selectedType"
                    placeholder="Select" (onChange)="onTypeSelected(selectedType.id)"></p-dropdown>
                </div>
              </div>
              <div class="p-col-3">
                <div class="filteritem" id="brand" *ngIf="lang=='CN'">
                  <span>品牌: </span>
                  <p-dropdown [ngClass]="{'brand-top': true}"  [autofocusFilter]='false' baseZIndex=1000 [hideTransitionOptions]="'0ms'"
                    emptyFilterMessage="没有相关品牌" optionLabel="name" [filter]="true" [options]="brands" [virtualScroll]="true" itemSize="30"
                    [(ngModel)]="selectedBrand" placeholder="选择品牌" [disabled]="isLoading" 
                    (onChange)="onBrandSelected(selectedBrand)"></p-dropdown>
                </div>
                <div class="filteritem" *ngIf="lang=='EN'">
                  <span>Brand: </span>
                  <p-dropdown  [ngClass]="{'brand-top': true}" id="en-brand" [autofocusFilter]='false' baseZIndex=1000 [hideTransitionOptions]="'0ms'"
                    [disabled]="isLoading" optionLabel="name" [filter]="true" [options]="brands" [(ngModel)]="selectedBrand" [virtualScroll]="true" itemSize="30"
                    placeholder="Select" (onChange)="onBrandSelected(selectedBrand)"></p-dropdown>
                </div>
              </div>
              <!-- 子筛选 -->
              <div class="p-col-3">
                <div class="filteritem" *ngIf="selectedBrand && selectedBrand.types && lang=='CN'">
                  <span>子类型: </span>
                  <p-dropdown  [ngClass]="{'brand-top': true}"  id="sub-type" 
                    [disabled]="isLoading" optionLabel="name" [options]="selectedBrand.types" baseZIndex=1000
                    [(ngModel)]="selectedBrandType" (onChange)="onDetailClick()">
                  </p-dropdown>
                </div>
                <div class="filteritem" *ngIf="selectedBrand && selectedBrand.types && lang=='EN'">
                  <span>SubType:</span>
                  <p-dropdown [ngClass]="{'brand-top': true}"  id="en-sub-type" 
                    [disabled]="isLoading" optionLabel="enName" [options]="selectedBrand.types" baseZIndex=1000
                    [(ngModel)]="selectedBrandType" (onChange)="onDetailClick()">
                  </p-dropdown>
                </div>
              </div>
              <div class="p-col-3">
                <div class="filteritem">

                  <div>
                    <div *ngIf="lang=='CN'">
                      <span>自定义: </span>
                      <p-multiSelect [ngClass]="{'brand-top': true}" id="customize" [options]="filters" [filter]="false" [(ngModel)]="selectedShowCols"
                        (onChange)="onShowColsSelect($event)" emptyFilterMessage="" defaultLabel="筛选条件" baseZIndex=100 emptyFilterMessage="没有数据"
                        selectedItemsLabel="已选择{0}个条件">
                      </p-multiSelect>
                    </div>
                    <div *ngIf="lang=='EN'">
                      <span>Customize: </span>
                      <p-multiSelect [ngClass]="{'brand-top': true}"  id="en-customize" [options]="filters" [filter]="false" [(ngModel)]="selectedShowCols" baseZIndex=100
                        (onChange)="onShowColsSelect($event)"></p-multiSelect>
                    </div>


                  </div>
                </div>
              </div>

            </div>
          </div>
          <!-- <div class="p-col-1"></div> -->
          <div class="p-col-1" style="text-align: right; ">
            <div *ngIf="lang=='CN'">
              <button pButton type="button" label="重置筛选" class="ui-button-primary" (click)="onReset()" [disabled] = "resetting && (headerValues === undefined)"></button>
            </div>
            <div *ngIf="lang=='EN'">
              <button pButton type="button" label="Reset" class="ui-button-primary" (click)="onReset()" [disabled] = "resetting && (headerValues === undefined)"></button>
            </div>
          </div>
        </div>
        <div *ngIf="selectedShowCols && selectedShowCols.length > 0">
          <div class="p-grid filter">
            <ng-container *ngFor="let col of cols; let i=index">
              <div *ngIf="needShow(col)" class="p-col-3">
                <div>
                  <div class="p-grid" *ngIf="lang=='CN'">
                    <div class="p-xl-4 p-lg-12 p-md-12 p-sm-12"
                      style="text-align: left;display: flex; margin: 0px;padding: 0px;"><span
                        style="align-self:center;">{{col.header}}:</span></div>
                    <div class="p-xl-8 p-lg-12 p-md-12 p-sm-12" style="text-align: left;margin: 0px;padding: 0px">
                      <span>
                        <p-dropdown [style]="{width: '85%'}" emptyFilterMessage="没有数据" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"  [autofocusFilter]='false' 
                          [filter]="!checkShowFilter(col.header)? true: false" [options]="filterItems[i]" (onChange)="onChange(i, $event)"></p-dropdown>
                      </span>
                    </div>
                  </div>
                  <div class="p-grid" *ngIf="lang=='EN'">
                    <div class="p-xl-4 p-lg-12  p-md-12" style="text-align: left;display: flex;; margin: 0px;padding: 0px;">
                      <span style="align-self:center;">{{col.header}}:</span></div>
                    <div class="p-xl-8 p-lg-12 p-md-12" style="text-align: left; margin: 0px;padding: 0px;">
                      <span>
                        <p-dropdown [style]="{width: '85%'}" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"  [autofocusFilter]='false'
                          [filter]="!checkShowFilter(col.header)? true: false" [options]="filterItems[i]" (onChange)="onChange(i, $event)"></p-dropdown>
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class=" c-p-sel">
        <div class="p-grid condition p-align-center" style="padding: 5px 15px;">
          <div >
            <div class="p-grid">
              <div class="p-col-12">
                <div class="filteritem" *ngIf="lang=='CN'">
                  <span>&nbsp;&nbsp;&nbsp;类型: </span>
                  <p-dropdown id="type" baseZIndex=1000 [ngClass]="{'brand-top': true}"
                    [disabled]="isLoading" emptyFilterMessage="没有类型" optionLabel="name" [options]="vehicleSwTypes"
                    [(ngModel)]="selectedType" placeholder="选择类型" (onChange)="onTypeSelected(selectedType.id)">
                  </p-dropdown>
                </div>
                <div class="filteritem c-en-dropdown" *ngIf="lang=='EN'">
                  <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Type: </span>
                  <p-dropdown id="en-type" baseZIndex=1000 [ngClass]="{'brand-top': true}" 
                    [disabled]="isLoading" optionLabel="enName" [options]="vehicleSwTypes" [(ngModel)]="selectedType"
                    placeholder="Select" (onChange)="onTypeSelected(selectedType.id)"></p-dropdown>
                </div>
              </div>
              <div class="p-col-12">
                <div class="filteritem" id="brand" *ngIf="lang=='CN'">
                  <span>&nbsp;&nbsp;&nbsp;品牌: </span>
                  <p-dropdown [ngClass]="{'brand-top': true}"  [autofocusFilter]='false' baseZIndex=1000 [hideTransitionOptions]="'0ms'"
                    emptyFilterMessage="没有相关品牌" optionLabel="name" [filter]="true" [options]="brands" [virtualScroll]="true" itemSize="30"
                    [(ngModel)]="selectedBrand" placeholder="选择品牌" [disabled]="isLoading" 
                    (onChange)="onBrandSelected(selectedBrand)"></p-dropdown>
                </div>
                <div class="filteritem c-en-dropdown" *ngIf="lang=='EN'">
                  <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Brand: </span>
                  <p-dropdown  [ngClass]="{'brand-top': true}" id="en-brand" [autofocusFilter]='false' baseZIndex=1000 [hideTransitionOptions]="'0ms'"
                    [disabled]="isLoading" optionLabel="name" [filter]="true" [options]="brands" [(ngModel)]="selectedBrand" [virtualScroll]="true" itemSize="30"
                    placeholder="Select" (onChange)="onBrandSelected(selectedBrand)"></p-dropdown>
                </div>
              </div>
              <!-- 子筛选 -->
              <div class="p-col-12">
                <div class="filteritem" *ngIf="selectedBrand && selectedBrand.types && lang=='CN'">
                  <span>子类型: </span>
                  <p-dropdown  [ngClass]="{'brand-top': true}"  id="sub-type" 
                    [disabled]="isLoading" optionLabel="name" [options]="selectedBrand.types" baseZIndex=1000
                    [(ngModel)]="selectedBrandType" (onChange)="onDetailClick()">
                  </p-dropdown>
                </div>
                <div class="filteritem c-en-dropdown" *ngIf="selectedBrand && selectedBrand.types && lang=='EN'">
                  <span>&nbsp;&nbsp;&nbsp;SubType:</span>
                  <p-dropdown [ngClass]="{'brand-top': true}"  id="en-sub-type"
                    [disabled]="isLoading" optionLabel="enName" [options]="selectedBrand.types" baseZIndex=1000
                    [(ngModel)]="selectedBrandType" (onChange)="onDetailClick()">
                  </p-dropdown>
                </div>
              </div>
              <div class="p-col-12">
                <div class="filteritem">

                  <div>
                    <div *ngIf="lang=='CN'">
                      <span>自定义: </span>
                      <p-multiSelect [ngClass]="{'brand-top': true}" id="customize" [options]="filters" [filter]="false" [(ngModel)]="selectedShowCols"
                        (onChange)="onShowColsSelect($event)" emptyFilterMessage="" defaultLabel="筛选条件" baseZIndex=100 emptyFilterMessage="没有数据"
                        selectedItemsLabel="已选择{0}个条件">
                      </p-multiSelect>
                    </div>
                    <div *ngIf="lang=='EN'">
                      <span>Customize: </span>
                      <p-multiSelect [ngClass]="{'brand-top': true}"  id="en-customize" [options]="filters" [filter]="false" [(ngModel)]="selectedShowCols" baseZIndex=100
                        (onChange)="onShowColsSelect($event)"></p-multiSelect>
                    </div>


                  </div>
                </div>
              </div>
              <div  class="p-col-12" *ngIf="selectedShowCols && selectedShowCols.length > 0">
                <div class="p-grid filter">
                  <ng-container *ngFor="let col of cols; let i=index">
                    <div *ngIf="needShow(col)" class="p-col-6">
                      <div class="p-grid" *ngIf="lang=='CN'">
                        <div class=""
                          style="text-align: left;display: flex; margin: 0px;padding: 0px;">
                          <span
                            style="align-self:center;">{{col.header}}:
                          </span>
                        </div>
                        <div class="" style="text-align: left;margin: 0px;padding: 0px">
                          <span>
                            <p-dropdown [style]="{width: '95%'}" emptyFilterMessage="没有数据" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"  [autofocusFilter]='false' 
                              [filter]="!checkShowFilter(col.header)? true: false" [options]="filterItems[i]" (onChange)="onChange(i, $event)"></p-dropdown>
                          </span>
                        </div>
                      </div>
                      <div class="p-grid" *ngIf="lang=='EN'">
                        <div class="p-xl-4 p-lg-12  p-md-12" style="text-align: left;display: flex;; margin: 0px;padding: 0px;">
                          <span style="align-self:center;">{{col.header}}:</span></div>
                        <div class="p-xl-8 p-lg-12 p-md-12" style="text-align: left; margin: 0px;padding: 0px;">
                          <span>
                            <p-dropdown [style]="{width: '85%'}" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"  [autofocusFilter]='false'
                              [filter]="!checkShowFilter(col.header)? true: false" [options]="filterItems[i]" (onChange)="onChange(i, $event)"></p-dropdown>
                          </span>
                        </div>
                      </div>      
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="p-col-1"></div> -->
          <div >
            <div *ngIf="lang=='CN'" style="text-align: right; ">
              <button pButton type="button" label="重置筛选" class="ui-button-primary" (click)="onReset()" [disabled] = "resetting && (headerValues === undefined)"></button>
            </div>
            <div *ngIf="lang=='EN'" style="text-align: right; ">
              <button pButton type="button" label="Reset" class="ui-button-primary" (click)="onReset()" [disabled] = "resetting && (headerValues === undefined)"></button>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="content data-min-height">

      <!-- <div class="title" *ngIf="lang=='CN'">可测车型详情</div>
      <div class="title" *ngIf="lang=='EN'">Detail</div> -->
      <div style="padding: 10px; background-color: #E5E5E5;position: relative;">
        <div style="position: absolute; left: 10px; top: 2.6rem; z-index: 1000;" *ngIf="showColumnsSelectBox">
          <p-listbox [style]="{'width': '16rem'}" [options]="filters" [(ngModel)]="showCols" optionLabel="label"
            [multiple]="true" [checkbox]="true" [filter]="true">
            <p-header>
              <div style="padding-top: 10px; padding-bottom: 10px; font-size: 1.2em;">
                <span style="float: left; font-weight: 600;">
                  <span *ngIf="lang=='CN'">列显示配置</span>
                  <span *ngIf="lang=='EN'">Show Columns</span>
                </span>
                <span style="float: right;" (click)="showColumnsSelectBox = false"><i class="pi pi-times"></i></span>
              </div>
            </p-header>
          </p-listbox>

        </div>
        <div *ngIf="lang=='CN'">
          <div>
            <span (click)="showColumnsSelectBox = !showColumnsSelectBox"
              style="color: #333; padding-right: 20px; font-size: 1.1em;"><button pButton type="button" icon="pi pi-list"
                style="margin-right: 10px;"></button><span>数据列表</span>
                <span class="c-p-sel" *ngIf="selectedBrand" (click)="onVersionClick(selectedBrand)"
                style="font-size: small; cursor: pointer; color: #9C3937;  padding-left: 20px;padding-top: 3px; display: inline;">版本号：{{selectedBrand.version}}
              </span>
            </span>
            <span class="c-p-sel" >
              <span style="color: #999999; font-size: small;">
                注释：
                ●：完全支持&nbsp;&nbsp; ▲：新增功能&nbsp;&nbsp;
                ○：不支持&nbsp;&nbsp; ※：部分支持&nbsp;&nbsp;
                *：仅支持12V的车辆
              </span>

            </span>
            <span class="c-l-sel" >
              <span style="color: #999999; font-size: small;">
                注释：
                ●：完全支持&nbsp;&nbsp; ▲：新增功能&nbsp;&nbsp;
                ○：不支持&nbsp;&nbsp; ※：部分支持&nbsp;&nbsp;
                *：仅支持12V的车辆
              </span>
              <span *ngIf="selectedBrand" (click)="onVersionClick(selectedBrand)"
                style="float: right; cursor: pointer; color: #9C3937;  padding-right: 20px;padding-top: 5px">版本号：{{selectedBrand.version}}
              </span>
            </span>
          </div>
        </div>
        <div *ngIf="lang=='EN'" style="color: #999999;">
          <div>
            <span (click)="showColumnsSelectBox = !showColumnsSelectBox"
              style="color: #333; padding-right: 20px; font-size: 1em;"><button pButton type="button" icon="pi pi-list"
                style="margin-right: 10px;"></button><span>Data List</span></span>
                
            
            <span *ngIf="selectedBrand" (click)="onVersionClick(selectedBrand)"
              style="float: right; cursor: pointer; color: #9C3937; padding-right: 10px;padding-top: 5px;">Version：{{selectedBrand.version}}</span>
          </div>
          <div style="color: #999999;">
            NOTES：
            ●：Supported&nbsp;&nbsp; ▲：New feature&nbsp;&nbsp;
            ○：Not supported &nbsp;&nbsp; ※：Partial supported&nbsp;&nbsp; 
            *: Only supports the diagnosis of 12V vehicles
          </div>

        </div>
      </div>
      <div *ngIf="vehicleTestableSws.length > 0" class="c-l-sel">

        <p-table #tt [columns]="cols" [value]="vehicleTestableSws" [paginator]="true" [rows]="rowsPerPage"
          [showCurrentPageReport]="false" [resizableColumns]="true" [(first)]="first">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <ng-container *ngFor="let col of columns; let i=index">
                <th *ngIf="showCol(col)" style="text-align: center;" 
                [ngClass]="{'th-width': i < 2, 'special-width': (isContain(col.header, '特殊功能') || isContain(col.header.toLowerCase(), 'special')) && (cols.length > 5)}" pResizableColumn>
                  {{col.header}}
                </th>
              </ng-container>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
              <ng-container *ngFor="let col of columns; let i=index">
                <td *ngIf="showCol(col)" style="text-align: center;" class="ui-resizable-column">
                  <div *ngIf="!(isContain(col.header, '特殊功能') || isContain(col.header.toLowerCase(), 'special')) 
                    || ((isContain(col.header, '特殊功能') || isContain(col.header.toLowerCase(), 'special')) && this.specialVehicleContents == undefined) ">
                    {{rowData[col.field]}}</div>
                  <div *ngIf="(isContain(col.header, '特殊功能') || isContain(col.header.toLowerCase(), 'special')) && this.specialVehicleContents !== undefined">
                    <a style="cursor: pointer;word-wrap: break-word; " class="td-max-line"
                      (click)="onSpecialClick(rowData[col.field])">
                      <!-- {{rowData[col.field]}} -->
                      <span *ngIf="rowData[col.field] !== '' && lang=='CN'">点击查看</span>
                      <span *ngIf="rowData[col.field] !== '' &&lang=='EN'">View</span>
                    </a>
                  </div>
                </td>
              </ng-container>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div style="text-align: center" class="summary">
              <span class="paginator-disp">
                <p-paginator [(first)]="first" [rows]="rowsPerPage" [totalRecords]="vehicleTestableSws.length"
                  [templateLeft]="tpl" [templateRight]="tplr" (onPageChange)="paginate($event)"
                  [rowsPerPageOptions]="[15,30,50]">
                </p-paginator>
              </span>
              <ng-template #tpl>
                <div class="c-l-sel" style="margin-top: 5px;" [innerHTML]="getPageInfo() | safeHtml"></div>
              </ng-template>
              <ng-template #tplr>
                <div class="c-l-sel">
                  <div *ngIf="lang=='CN'">
                    <span>转至</span>
                    <p-inputNumber [style]="{padding: '5px'}" [(ngModel)]="currentPage"
                      (ngModelChange)="pageChanged($event)"></p-inputNumber>
                    <span>页</span>
                  </div>
                  <div *ngIf="lang=='EN'">
                    <span>To</span>
                    <p-inputNumber [style]="{padding: '5px'}" [(ngModel)]="currentPage"
                      (ngModelChange)="pageChanged($event)"></p-inputNumber>
                    <span>Page</span>
                  </div>
                </div>
              </ng-template>
            </div>
          </ng-template>
        </p-table>
      </div>
      <div *ngIf="vehicleTestableSws.length > 0" class="c-p-sel">

        <p-table #tt [columns]="cols" [value]="vehicleTestableSws" [paginator]="true" [rows]="rowsPerPage"
          [showCurrentPageReport]="false" [scrollable]="true"  [(first)]="first">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <ng-container *ngFor="let col of columns; let i=index">
                <th *ngIf="showCol(col)" style="text-align: center; " [ngStyle]="{'min-width': (i==0 ? '103px': '88px') }"
               >
                  {{col.header}}
                </th>
              </ng-container>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
              <ng-container *ngFor="let col of columns; let i=index">
                <td *ngIf="showCol(col)" style="text-align: center;min-width: 88px;">
                  <div *ngIf="!(isContain(col.header, '特殊功能') || isContain(col.header.toLowerCase(), 'special')) 
                    || ((isContain(col.header, '特殊功能') || isContain(col.header.toLowerCase(), 'special')) && this.specialVehicleContents == undefined) ">
                    {{rowData[col.field]}}</div>
                  <div *ngIf="(isContain(col.header, '特殊功能') || isContain(col.header.toLowerCase(), 'special')) && this.specialVehicleContents !== undefined">
                    <a style="cursor: pointer;word-wrap: break-word; " class="td-max-line"
                      (click)="onSpecialClick(rowData[col.field])">
                      <!-- {{rowData[col.field]}} -->
                      <span *ngIf="rowData[col.field] !== '' && lang=='CN'">点击查看</span>
                      <span *ngIf="rowData[col.field] !== '' &&lang=='EN'">View</span>
                    </a>
                  </div>
                </td>
              </ng-container>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div style="text-align: center" class="summary">
              <span class="paginator-disp">
                <p-paginator [(first)]="first" [rows]="rowsPerPage" pageLinkSize="3" [totalRecords]="vehicleTestableSws.length"
                  [templateLeft]="tpl" [templateRight]="tplr" (onPageChange)="paginate($event)">
                </p-paginator>
              </span>
              
            </div>
          </ng-template>
        </p-table>
      </div>
      <div *ngIf="isLoading">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="4" fill="#EEEEEE"
          animationDuration=".5s"></p-progressSpinner>
      </div>
      <div class="no-data" *ngIf="isLoading == false && vehicleTestableSws.length == 0 && lang=='CN'">
        没有可测车型数据
      </div>
      <div class="no-data" *ngIf="isLoading == false && vehicleTestableSws.length == 0 && lang=='EN'">
        No data for selected brand
      </div>
    </div>
  </div>
</div>
<p-dialog [(visible)]="display" [responsive]="true" [closable]='false'  (onHide)="onHideDialog()" [modal]="true" [blockScroll]='true' (click)="display = false"
[style]="{width: '500px', minWidth: '200px'}" baseZIndex=100>
<p-header>
  <span style="vertical-align: middle;font-size: 1.2em;">{{dialog.title}}</span>
  <!-- <button style="float: right; font-size: 0.6em; width: 4em; height: 2em;" id="closedialog" pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-danger p-button-text"></button> -->
  <button style="float: right; font-size: 0.8em; " id="closedialog" pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-danger p-button-outlined"></button>
</p-header>
<div id='diaContent' [innerHTML]="dialog.curLatestVersionInfo | safeHtml" style=" min-height: 250px;  min-width: 400px;max-height: 60vh;">
</div>
</p-dialog>
